import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios';
import { environment } from '../../environment';
import { Button, Card, CardActionArea, CardActions, CardContent, CardMedia, Container, Typography } from '@mui/material';
import { TextField } from '@mui/material';
import swal from 'sweetalert';

const SingleTermin = () => {
    
    const { id } = useParams();
    const apiurl = environment.LOCALHOST_URL;
    const [singleTermin, setsingleTermin] = useState([])
    const [client, setclient] = useState('')
    const [date, setdate] = useState('')
    const [hour, sethour] = useState('')
    const [price, setprice] = useState(0)

    useEffect(() => {
         axios.get(`${apiurl}/termin/single/${id}`).then((res) => {
            setsingleTermin(res.data);
        })
    }, [])
   
    async function handleEdit() {
            await axios(`${apiurl}/termin/edit/${id}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify({
                    client: client,
                    terminDate: date,
                    terminHour: hour,
                    price: price
                })
            }).then((res) => {
                console.log({res});
                if(res.status === 200) {
                    swal({
                        title: `Ndryshymet u ruajten me sukses`,
                        buttons: {
                          cancel: 'Mbyll',
                        },
                      })

                      setInterval(() => {
                        window.location.reload();
                      }, 3000)

                } else {
                    swal({
                        title: `Dicka shkoi keq, provoni perseri!`,
                        buttons: {
                          cancel: 'Mbyll',
                        },
                      })

                      setInterval(() => {
                        window.location.reload();
                      }, 3000);
                }
            })
    }
        
    const newClient = (e) => {
        console.log(e.target.value)
        setclient(e.target.value);
    }    

    const newterminDate = (e) => {
        console.log(e.target.value)
        setdate(e.target.value);
    }   

    const newterminHour = (e) => {
        console.log(e.target.value);
        sethour(e.target.value);
    }   

    const newprice = (e) => {
        console.log(e.target.value);
        setprice(e.target.value);
    }   



    return (
        <div>
            {
                <Container style={{marginTop:'50px'}}>
                    <Card>
                        <CardActionArea>
                          <CardContent>

                            <Typography variant="body2" color="text.secondary">
                                Paguar : {singleTermin.isPaid === true ? <p className='badge bg-success'>po</p> : <p className='badge bg-danger'>jo</p>}
                            </Typography>

                            <Typography gutterBottom variant="h5" component="div">
                                <TextField id="standard-basic" label={singleTermin.client} variant="standard" onChange={newClient} />
                            </Typography>

                            <Typography variant="body2" color="text.secondary">
                                <TextField id="standard-basic" label={singleTermin.terminDate} variant="standard" onChange={newterminDate} />
                            </Typography>

                            <Typography variant="body2" color="text.secondary">
                                <TextField id="standard-basic" label={singleTermin.terminHour} variant="standard" onChange={newterminHour} />
                            </Typography>

                            {singleTermin.isPaid === false ? 
                                <TextField id="standard-basic" label={ 'Cmimi' + ' : ' + singleTermin.price} variant="standard" onChange={newprice} />
                            : ""}

                          </CardContent>
                        </CardActionArea>
                        <CardActions>
                          <Button onClick={handleEdit} size="small" color="primary">
                            Ruaj ndryshimet
                          </Button>
                        </CardActions>
                      </Card>
                </Container>
            }
        </div>
    )
}

export default SingleTermin;
